import { useState, FunctionComponent, ReactNode } from 'react'
import { DateTime } from 'luxon'

import SingleDatePicker from './SingleDatePicker'

interface SingleDateCalendarProps {
  id: string
  availableDays: string[]
  selectedDate: DateTime | null
  onSelectDate: (date: DateTime) => void
  customInput?: ReactNode
  disabled?: boolean
}

const SingleDateCalendar: FunctionComponent<SingleDateCalendarProps> = ({
  id,
  availableDays,
  selectedDate,
  onSelectDate,
  customInput,
  disabled,
}) => {
  const [focusedInput, setFocusedInput] = useState({ focused: false })

  const onCancel = (): void => {
    return setFocusedInput({ focused: false })
  }

  return (
    <SingleDatePicker
      availableDays={availableDays}
      date={selectedDate != null ? selectedDate.toJSDate() : null}
      onDateChange={(date) => {
        if (date != null) {
          setFocusedInput({ focused: false })
          onSelectDate(DateTime.fromJSDate(date))
        }
      }}
      focused={focusedInput.focused}
      onFocusChange={(item) => {
        setFocusedInput({ focused: item.focused === true })
      }}
      id={id}
      onCancel={onCancel}
      customInput={customInput}
      disabled={disabled}
    />
  )
}
export default SingleDateCalendar
